import classNames from 'classnames'
import React from 'react'

import { ColorFilter, ColorFilterProps } from '../colorFilter'

import styles from './colorFilterGroup.module.scss'

export interface ColorFilterGroupProps {
  options: Omit<ColorFilterProps, 'onChange' | 'selected'>[]
  selectedValues: string[]
  onChange: (value: string) => void
  direction?: 'horizontal' | 'vertical'
  className?: string
  colorFilterClassName?: string
  circleClassName?: string
  labelClassName?: string
  columns?: number
  circleSize?: number
  rowGap?: number
  columnGap?: number | 'auto'
}

export const ColorFilterGroup: React.FC<ColorFilterGroupProps> = ({
  options,
  selectedValues,
  onChange,
  direction = 'horizontal',
  className,
  colorFilterClassName,
  circleClassName,
  labelClassName,
  columns,
  circleSize = 3.6,
  rowGap = 1.6,
  columnGap = 'auto',
}) => {
  const containerClasses = classNames(
    styles.container,
    direction === 'horizontal' ? styles.horizontal : styles.vertical,
    columns && styles.gridLayout,
    className,
  )

  const containerStyle = columns
    ? {
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        rowGap: `${rowGap}rem`,
        columnGap: columnGap === 'auto' ? 'auto' : `${columnGap}rem`,
      }
    : undefined
  const circleStyle = { width: `${circleSize}rem`, height: `${circleSize}rem` }

  return (
    <div className={containerClasses} style={containerStyle} role="group" aria-label="Color filter options">
      {options.map(option => (
        <ColorFilter
          key={option.value}
          {...option}
          selected={selectedValues.includes(option.value)}
          onChange={onChange}
          className={colorFilterClassName}
          circleClassName={circleClassName}
          labelClassName={labelClassName}
          aria-checked={selectedValues.includes(option.value)}
          style={circleStyle}
        />
      ))}
    </div>
  )
}
